export var Colors = {
    // Grescale colors
    WHITE: '#FFFFFF',
    GREY50: '#FAFAFA',
    GREY100: '#F5F5F5',
    GREY200: '#EEEEEE',
    GREY300: '#E0E0E0',
    GREY400: '#BDBDBD',
    GREY500: '#9E9E9E',
    GREY600: '#757575',
    GREY700: '#616161',
    GREY800: '#424242',
    GREY900: '#212121',
    BLUE_GREY50: '#E4E9EB',
    BLUE_GREY100: '#CFD8DC',
    BLUE_GREY200: '#B0BEC5',
    BLUE_GREY300: '#90A4AE',
    BLUE_GREY400: '#78909C',
    BLUE_GREY500: '#607D8B',
    BLUE_GREY600: '#546E7A',
    BLUE_GREY700: '#455A64',
    BLUE_GREY800: '#37474F',
    BLUE_GREY900: '#263238',
    // CORE COLORS
    RED50: '#FFEBEE',
    RED100: '#FFCDD2',
    RED200: '#EF9A9A',
    RED300: '#E57373',
    RED400: '#EF5350',
    RED500: '#F44336',
    RED600: '#E53935',
    RED700: '#D32F2F',
    RED800: '#C62828',
    RED900: '#B71C1C',
    PURPLE50: '#F3E5F5',
    PURPLE100: '#E1BEE7',
    PURPLE200: '#CE93D8',
    PURPLE300: '#BA68C8',
    PURPLE400: '#AB47BC',
    PURPLE500: '#9C27B0',
    PURPLE600: '#8E24AA',
    PURPLE700: '#7B1FA2',
    PURPLE800: '#6A1B9A',
    PURPLE900: '#4A148C',
    DEEP_PURPLE50: '#EDE7F6',
    DEEP_PURPLE100: '#D1C4E9',
    DEEP_PURPLE200: '#B39DDB',
    DEEP_PURPLE300: '#9575CD',
    DEEP_PURPLE400: '#7E57C2',
    DEEP_PURPLE500: '#673AB7',
    DEEP_PURPLE600: '#5E35B1',
    DEEP_PURPLE700: '#512DA8',
    DEEP_PURPLE800: '#4527A0',
    DEEP_PURPLE900: '#311B92',
    INDIGO50: '#E8EAF6',
    INDIGO100: '#C5CAE9',
    INDIGO200: '#9FA8DA',
    INDIGO300: '#7986CB',
    INDIGO400: '#5C6BC0',
    INDIGO500: '#3F51B5',
    INDIGO600: '#3949AB',
    INDIGO700: '#303F9F',
    INDIGO800: '#283593',
    INDIGO900: '#1A237E',
    BLUE50: '#E3F2FD',
    BLUE100: '#BBDEFB',
    BLUE200: '#90CAF9',
    BLUE300: '#64B5F6',
    BLUE400: '#42A5F5',
    BLUE500: '#2196F3',
    BLUE600: '#1E88E5',
    BLUE700: '#1976D2',
    BLUE800: '#1565C0',
    BLUE900: '#0D47A1',
    LIGHT_BLUE50: '#E1F5FE',
    LIGHT_BLUE100: '#B3E5FC',
    LIGHT_BLUE200: '#81D4FA',
    LIGHT_BLUE300: '#4FC3F7',
    LIGHT_BLUE400: '#29B6F6',
    LIGHT_BLUE500: '#03A9F4',
    LIGHT_BLUE600: '#039BE5',
    LIGHT_BLUE700: '#0288D1',
    LIGHT_BLUE800: '#0277BD',
    LIGHT_BLUE900: '#01579B',
    CYAN50: '#E0F7FA',
    CYAN100: '#B2EBF2',
    CYAN200: '#80DEEA',
    CYAN300: '#4DD0E1',
    CYAN400: '#26C6DA',
    CYAN500: '#00BCD4',
    CYAN600: '#00ACC1',
    CYAN700: '#0097A7',
    CYAN800: '#00838F',
    CYAN900: '#006064',
    TEAL50: '#E0F2F1',
    TEAL100: '#B2DFDB',
    TEAL200: '#80CBC4',
    TEAL300: '#4DB6AC',
    TEAL400: '#26A69A',
    TEAL500: '#009688',
    TEAL600: '#00897B',
    TEAL700: '#00796B',
    TEAL800: '#00695C',
    TEAL900: '#004D40',
    GREEN50: '#E8F5E9',
    GREEN100: '#C8E6C9',
    GREEN200: '#A5D6A7',
    GREEN300: '#81C784',
    GREEN400: '#66BB6A',
    GREEN500: '#4CAF50',
    GREEN600: '#43A047',
    GREEN700: '#388E3C',
    GREEN800: '#2E7D32',
    GREEN900: '#1B5E20',
    LIGHT_GREEN50: '#F1F8E9',
    LIGHT_GREEN100: '#DCEDC8',
    LIGHT_GREEN200: '#C5E1A5',
    LIGHT_GREEN300: '#AED581',
    LIGHT_GREEN400: '#9CCC65',
    LIGHT_GREEN500: '#8BC34A',
    LIGHT_GREEN600: '#7CB342',
    LIGHT_GREEN700: '#689F38',
    LIGHT_GREEN800: '#558B2F',
    LIGHT_GREEN900: '#33691E',
    ORANGE50: '#FFF3E0',
    ORANGE100: '#FFE0B2',
    ORANGE200: '#FFCC80',
    ORANGE300: '#FFB74D',
    ORANGE400: '#FFA726',
    ORANGE500: '#FF9800',
    ORANGE600: '#FB8C00',
    ORANGE700: '#F57C00',
    ORANGE800: '#EF6C00',
    ORANGE900: '#E65100'
};
